import { Fragment } from 'react';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import type { CurrencyData } from '#src/components/navigation/AppNavigation/UserCurrencies/useUserCurrencies.tsx';
import { useSportContext } from '#src/contexts/sport/index.ts';

type Props = {
  open?: boolean;
  onClose?: () => void;
  currencies: CurrencyData[];
};
export const MobileUserCurrenciesDialog = ({
  open,
  onClose,
  currencies,
}: Props) => {
  const { sport } = useSportContext();
  return (
    <Dialog open={open} onClose={onClose}>
      <Vertical className="p-2">
        {currencies.map(
          ({ id, details, visibleOnSports }) =>
            visibleOnSports.includes(sport) && (
              <Fragment key={id}>{details?.({ onClick: onClose })}</Fragment>
            )
        )}
      </Vertical>
    </Dialog>
  );
};
